import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

export const PasswordHelperContent = styled.div`
  font-size: 0.8em;
  color: ${({ color }) => color || customTheme.colors.white};
  padding-left: 1em;
  margin-top: 1em;
  border-left: 1px solid ${({ color }) => color || customTheme.colors.white};

  span {
    font-weight: bold;
  }
`
